import axios, {
  AxiosInstance,
  AxiosRequestHeaders,
  AxiosResponse,
} from "axios";
import rateLimit, { RateLimitedAxiosInstance } from "axios-rate-limit";

export interface Options {
  baseHeaders?: AxiosRequestHeaders;
  rateLimitConfig?: {
    maxRequests?: number;
    perMilliseconds?: number;
    maxRPS?: number;
  };
}

export class BaseAxiosClient {
  protected readonly instance: AxiosInstance | RateLimitedAxiosInstance;

  constructor(options: Options) {
    const instance = axios.create({
      headers: {
        ...options?.baseHeaders,
        ContentType: "application/json",
      },
    });

    if (options.rateLimitConfig) {
      this.instance = rateLimit(instance, options?.rateLimitConfig);
    } else {
      this.instance = instance;
    }
  }

  protected receiveResponse<D, F>(response: AxiosResponse<D, F>) {
    if (response.status !== 200) {
      throw new Error(
        `Unexpected request error. status:${
          response.status
        }, data:${JSON.stringify(response.data)}`
      );
    }

    return response.data;
  }

  getInstance() {
    return this.instance;
  }
}
